const isDev = process.env.NODE_ENV !== 'production';

export const business = 'patientRecords';

export const publicPath = isDev ? '/' : '/archive/';

export const outputDir = isDev ? 'dist' : 'dist/archive/';

export const login = window.location.host;

export const baseURL = ''; // isDev ? 'http://111.231.14.172:8083' : '';

export const interfaceURL = `${baseURL}archive/interface/`;
